<script>
import { vPage } from "v-page";

import dateMixin from "@/mixins/dateMixin.js";
import timeMixin from "@/mixins/timeMixin.js";

export default {
  mixins: [dateMixin, timeMixin],
  props: {
    orders: {
      type: Array,
      required: true
    }
  },
  components: {
    vPage
  }
};
</script>

<template>
  <div class="card">
    <div class="row align-center">
      <div class="title">Pedidos</div>
    </div>

    <transition name="fade" mode="out-in">
      <div class="table">
        <table>
          <thead>
            <tr>
              <th>Profissional</th>
              <th>Data e duração</th>
              <th>Ação</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="order in orders" :key="order.id">
              <td>
                <div class="with-image">
                  <img :src="order.professional.account.profile.profile_picture" />
                  {{order.professional.account.first_name}} {{order.professional.account.last_name}}
                </div>
              </td>
              <td>{{order.schedule_event.starts_at | formatDate('DD/MM [às] H[h]')}} - {{order.schedule_event.duration | secToHours(true)}}</td>
              <td class="buttons" nowrap>
                <router-link
                  :to="'pedidos/'+order.id"
                  class="btn btn-small bg-purple-outline float-right"
                >ir para o pedido</router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </transition>
  </div>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Cycle/Orders/Desktop.vue